import React from 'react';
import { gsap } from "gsap/dist/gsap";
import { MotionPathPlugin } from "gsap/dist/MotionPathPlugin";

import { Path } from 'konva/lib/shapes/Path';


gsap.registerPlugin(MotionPathPlugin);


class AnimationAsClass extends React.Component { 

  myCircle = React.createRef();


  constructor(props){
    super(props);
    this.state = {
      left: 0,
      top: 0,
      width: 0,
      height: 0,
      startX: 0,
      startY: 0,
      path: 0,
      d: 0,
      radius: this.props.radius,
    }
  }

  componentDidMount() {
    this.setDimensions();
    window.addEventListener('resize', this.setDimensions);
  }

  setDimensions = async () => {
    const id = this.props.rectId;
    const svg = await document.querySelector('#arrow_'+id).children[0].childNodes[0];

    let dimensions = await svg.getBoundingClientRect();
    
    let p = svg.querySelector('path')
    let d = p.getPointAtLength(0);
    let pathString = p.getAttribute('d');

    this.setState({
    left: dimensions.left- (this.state.radius)*2,
    top: dimensions.top- (this.state.radius)*2,
    width:dimensions.width + ((this.state.radius*2)*2), 
    height:dimensions.height + ((this.state.radius*2)*2),
    startX: d.x+(this.state.radius)*2,
    startY: d.y+(this.state.radius)*2,
    path: p,
    d: pathString
    });
  }
  
  componentDidUpdate(prevProps) {
    if (this.props !== prevProps)
    {
      this.setDimensions();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setDimensions);
  }

  animation = (direction, duration, id) => {

    if (direction === 1){
      direction = "to";
    } else {
      direction = "from";
    }
    gsap[direction]('#' + id, 
    { 
    duration: duration,
    repeat: -1,
    ease: 'none', 
    motionPath: 
    {
      path: this.state.path,
      align: this.state.path,
      alignOrigin: [0.5, 0.5],
      autoRotate: true
    } 
    });
  }

  renderCircles = () => {

    let direction;
    let duration;
    let maxDuration = 4;
    let minDuration = 22;
    let loopIn;
    let loopOut;
    let color;
    let circleId;

    loopIn = this.props.in.map((info, index) => {

      duration = Math.abs((((info.energyKWh)/(this.props.total))*(maxDuration-minDuration)+minDuration))
      //duration = ((this.props.total / info.energyKWh) * maxDuration)
      

      color = info.color;
      circleId = ('c'+ this.props.rectId + index + '1');
      direction = info.energyDirection;
      
      return (
         <svg 
          height={this.state.height} 
          width={this.state.width}
          overflow="auto"
          style={{
            position: 'absolute',
            left: this.state.left + "px",
            top: this.state.top + "px",
            zIndex: 0
          }}>
          <circle
            r={this.state.radius} 
            fill={color}
            cx={this.state.startX }
            cy={this.state.startY }
            id={circleId}
            style={{
              zIndex: 12
            }}
          />
          {this.animation(direction, duration, circleId)}

      </svg>

      );
      //{this.animation(direction, testSpeed, circleId)}



    })
    loopOut = this.props.out.map((info, index) => {

      duration = Math.abs((((info.energyKWh)/(this.props.total))*(4-22)+22))


      color = info.color;
      circleId = ('c'+ this.props.rectId + index + '-1')
      direction = info.energyDirection;
      
      return (
         <svg 
          height={this.state.height} 
          width={this.state.width}
          overflow="auto"
          style={{
            position: 'absolute',
            left: this.state.left + "px",
            top: this.state.top + "px",
            zIndex: 0
          }}>
          <circle
            r={this.state.radius} 
            fill={color}
            cx={this.state.startX }
            cy={this.state.startY }
            id={circleId}
            style={{
              zIndex: 12
            }}
          />
          {this.animation(direction, duration, circleId)}

      </svg>

      );
      //{this.animation(direction, testSpeed, circleId)}



    })
    return [loopIn, loopOut];
  }

  /* this will do the same, but with props.data
  renderCirclesB = () => {
    let direction;
    let testSpeed;
    let loop;
    let color;
    let circleId;

    console.log(this.props.in);

    loop = this.props.data.map((info, index) => {

      testSpeed = index+1;
      color = info.color;
      circleId = ('c'+ this.props.rectId + index)
      direction = info.energyDirection;

      return (
         <svg 
          height={this.state.height} 
          width={this.state.width}
          overflow="auto"
          style={{
            position: 'absolute',
            left: this.state.left + "px",
            top: this.state.top + "px",
            zIndex: 0
          }}>
          <circle
            r={this.state.radius} 
            fill={color}
            cx={this.state.startX }
            cy={this.state.startY }
            id={circleId}
            style={{
              zIndex: 12
            }}
          />
          {this.animation(direction, testSpeed, circleId)}

      </svg>

      );
      //{this.animation(direction, testSpeed, circleId)}



    })

    return loop;
    
    //1 get Color
    //2 get number + direction 

  }*/
 
  render(){

    return (
      <div className='ParentOfAnimation' id={this.props.rectId} key={"circle-"+this.props.rectId}>
        {this.renderCircles()}
      </div>
      
    );
    
    
};
}

export default AnimationAsClass;